export default __webpack_public_path__ + "static/media/cinV12.aacf9509.jpg";